import Script from 'next/script'

export function GoogleAnalytics() {
  return (
    <Script id="google-analytics" strategy="afterInteractive">
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-0BQX5T7N4T');
      `}
    </Script>
  )
}
